//TODO SACAR ADMINISTRATOR
export const buildLoggedUser = (user) => ({
  ...user,
  lastName: user.lastName,
  profile: buildProfile(user.projects),
});

const buildProfile = (projects) => {
  if (Array.isArray(projects) && projects.length) {
    // projects can be string[] (SIC multi-project format) or object[] with {profile}
    const firstItem = projects[0];
    if (typeof firstItem === 'string') {
      return ["administrator"];
    }
    const profiles = [];
    projects.forEach(({ profile }) => {
      if (profile?.code) profiles.push(profile.code);
    });
    return profiles.length ? profiles : ["administrator"];
  } else {
    return ["administrator"];
  }
};

/**
 * Verifica si un módulo existe y está habilitado en la configuración.
 *
 * @param {string} moduleKey - Identificador del módulo a verificar.
 * @param {Array<{ enabled: boolean, key: string }>} modules - Lista de configuraciones de módulos; cada una con un `key` y la propiedad `enabled`.
 * @throws {Error} - Lanza un error si el módulo no existe o está deshabilitado.
 * @returns {boolean} - Devuelve `true` si el módulo existe y está habilitado.
 */
export function validateModuleIsEnabled(moduleKey, modules) {
  const moduleConfig = modules.find((config) => config.key === moduleKey);

  if (!moduleConfig) return false;

  if (!moduleConfig.enabled) return false;

  return true;
}

/**
 * Normaliza una URL quitando el slash final si lo tiene.
 * @param {string} url - URL a normalizar.
 * @returns {string} - URL normalizada.
 */
export const normalizeUrl = (url) => {
  return url.endsWith("/") ? url.slice(0, -1) : url;
};
